var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationDark2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 0.5C4.5162 0.5 0.0820312 4.4125 0.0820312 9.25C0.0820312 15.8125 9.9987 25.5 9.9987 25.5C9.9987 25.5 19.9154 15.8125 19.9154 9.25C19.9154 4.4125 15.4812 0.5 9.9987 0.5ZM9.9987 12.375C8.0437 12.375 6.45703 10.975 6.45703 9.25C6.45703 7.525 8.0437 6.125 9.9987 6.125C11.9537 6.125 13.5404 7.525 13.5404 9.25C13.5404 10.975 11.9537 12.375 9.9987 12.375Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDark2);
export default __webpack_public_path__ + "static/media/location_dark2.64c0791d872d4c15de3f14fa86ddeb9d.svg";
export { ForwardRef as ReactComponent };